<script>
import { getRoomById } from '@/api/ops/conService'

export default {
  name: "FormAbstracts",
  data() {
    return {
      locationCache: {}
    }
  },
  mounted() {
    this.loadPositionData();
  },
  methods: {
    // 加载位置数据到缓存
    loadPositionData() {
      if (this.value && Array.isArray(this.value)) {
        this.value.forEach(item => {
          if (item.type === 'PositionAreaInput' && item.value && !this.locationCache[item.value]) {
            // 标记为加载中
            this.locationCache[item.value + '_loading'] = true;
            getRoomById(item.value).then(res => {
              this.locationCache[item.value] = res.data.data.locationArea + res.data.data.locationName;
              this.$forceUpdate(); // 强制更新组件以重新渲染
            }).catch(error => {
              console.error('获取位置列表失败:', error);
              this.locationCache[item.value] = item.value || '';
            });
          }
        });
      }
    },
    getTextVal(obj){
      switch (obj.type) {
        case 'DeptPicker':
        case 'UserPicker':
        case 'HighDeptPicker':
        case 'HighUserPicker':
        case 'FileUpload':
        case 'ImageUpload':
          if (typeof obj.value == 'string' && obj.value != "") return (JSON.parse(obj.value) || []).map(v => v.name).join('、');
          return (obj.value || []).map(v => v.name).join('、');
        case 'SelectPlus':
        case 'MultipleSelect':
        case 'TimeRangePicker':
        case 'DateTimeRange':
          if (typeof obj.value == 'string' && obj.value != "") return (JSON.parse(obj.value) || []).join('、');
          return (obj.value || []).join('、');
        case 'ProcessIndex':
          if (typeof obj.value == 'string' && obj.value != "") return (JSON.parse(obj.value) || []).map(v => v.startUser.name + '-' + v.name).join('、');
          return (obj.value || []).map(v => v.startUser.name + '-' + v.name).join('、');
        case 'PositionAreaInput':
          // 检查是否已有缓存数据
          if (this.locationCache[obj.value]) {
            return this.locationCache[obj.value];
          } else {
            // 如果没有缓存，先触发加载
            if (!this.locationCache[obj.value + '_loading']) {
              this.locationCache[obj.value + '_loading'] = true;
              getRoomById(obj.value).then(res => {
                this.locationCache[obj.value] = res.data.data.locationArea + res.data.data.locationName;
                this.$forceUpdate(); // 强制更新组件以重新渲染
              }).catch(error => {
                console.error('获取位置列表失败:', error);
                this.locationCache[obj.value] = obj.value || '';
              });
            }
            // 返回原始值直到异步加载完成
            return obj.value || '加载中...';
          }
        default:
          return obj.value;
      }
    }
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
}
</script>

<template>
<div>
  <div v-for="val in value" class="w-field">
    <span>{{val.name}}：</span>
    <span>{{getTextVal(val)}}</span>
  </div>
  <span v-if="value.length === 0">无</span>
</div>
</template>

<style scoped lang="less">
.w-field {
  & > span:first-child{
    color: #9b9595;
  }
}
</style>
